import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { frequentlyAskedQuestionsSectionStyles } from './FrequentlyAskedQuestionsSection.styles';
import FAQAccordion from './FAQAccordion/FAQAccordion';

const FrequentlyAskedQuestionsSection = () => {
  return (
    <Box sx={frequentlyAskedQuestionsSectionStyles.container}>
      <Grid
        container
        spacing={{xs: 1, lg: 4}}
        sx={frequentlyAskedQuestionsSectionStyles.gridContainer}
      >
        <Grid size={{ xs: 12, md: 6 }}>
          <Box sx={frequentlyAskedQuestionsSectionStyles.leftColumn}>
            <Typography sx={frequentlyAskedQuestionsSectionStyles.header}>
              Frequently Asked Questions
            </Typography>
            <Typography sx={frequentlyAskedQuestionsSectionStyles.title}>
              Everything You Need to Know
            </Typography>
            <Typography sx={frequentlyAskedQuestionsSectionStyles.content}>
              Royal Vista is designed to offer a seamless and refined stay experience. To make things easy, we've gathered answers to the most common questions from guests and property owners covering everything from booking and standards to support and stays.
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Box sx={frequentlyAskedQuestionsSectionStyles.rightColumn}>
            <FAQAccordion />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FrequentlyAskedQuestionsSection;

